const vuex = {
  modules: {
    activeDistricts: {}
  }
}

export default vuex;
